import { types } from 'mobx-state-tree';
import { handleTriggerEvent } from '../../implementation/ContextMenuImplementation';
var ContextMenuStore = types.model({ activeContextMenuKey: types.maybe(types.string) })
    .named('ContextMenuStore')
    .volatile(function (_self) { return ({ activeParameters: undefined }); })
    .views(function (self) { return ({
    get activeContextMenu() {
        if (!self.activeContextMenuKey) {
            return undefined;
        }
        return self.activeContextMenuKey;
    },
    getActiveParameters: function (key) {
        if (self.activeContextMenuKey !== key) {
            return undefined;
        }
        return self.activeParameters;
    }
}); })
    .actions(function (self) { return ({
    openContextMenu: function (triggerEvent, contextMenuToOpen, parameters) {
        handleTriggerEvent(triggerEvent, contextMenuToOpen);
        self.activeParameters = parameters;
        self.activeContextMenuKey = contextMenuToOpen;
        self.activeTriggerEvent = triggerEvent;
    },
    closeContextMenu: function () {
        self.activeContextMenuKey = undefined;
        self.activeParameters = undefined;
        self.activeTriggerEvent = undefined;
    }
}); });
export default ContextMenuStore;
//# sourceMappingURL=ContextMenuStore.js.map